import baseService from "@common/externos/services/base.service";
import store from "@common/store/store";

const tbRoute = window.api_routes.smarAPD_Tributario_Domain;
const commonRoute = window.api_routes.smarAPD_Common;

let http = baseService(store, tbRoute);

const apiDef = {
  validate(data, tokenRecaptcha) {
    return http.post(
      "/ParametroValorExterno/CrachaAmbulante/Validar",
      data,
      tokenRecaptcha
    );
  },
  getDadosAmbulante(data, tokenRecaptcha) {
    return http.post(
      "/ParametroValorExterno/CrachaAmbulante",
      data,
      tokenRecaptcha
    );
  }
};

export default apiDef;
